import { render, staticRenderFns } from "./ContactChoiceModal.vue?vue&type=template&id=0d484b78&scoped=true"
import script from "./ContactChoiceModal.vue?vue&type=script&lang=ts"
export * from "./ContactChoiceModal.vue?vue&type=script&lang=ts"
import style0 from "./ContactChoiceModal.vue?vue&type=style&index=0&id=0d484b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d484b78",
  null
  
)

export default component.exports